import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_EPO_WATCH_ACTION_TYPE } from '../actions/epoWatch.actions';

const initialState = null;

const epoWatchReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_EPO_WATCH_ACTION_TYPE.SET_EPO_WATCH:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default epoWatchReducer;
